export default "__VITE_ASSET__b58d6a7a__"